import * as React from 'react'
import { styled } from 'next-yak'
import * as S from '../../../styles'
import * as glyphs from '../../../icons/glyphs'
import * as behaviours from '../../../behaviours'

export type TimeInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'defaultValue'> & {
  value?: string
  defaultValue?: string
  status?: behaviours.FieldStatus
  timezone?: string
}

const TimeInputComponent = React.forwardRef<HTMLInputElement, TimeInputProps>(function TimeInputComponent(
  { className, timezone, ...inputProps },
  ref,
) {
  const inputRef = React.useRef<HTMLInputElement>(null)

  const setRef = React.useCallback(function setRef(node: HTMLInputElement) {
    const anyInputRef = inputRef as any
    anyInputRef.current = node
    if (ref) {
      const anyRef = ref as any
      if (typeof ref === 'function') {
        ref(node)
      } else {
        anyRef.current = node
      }
    }
  }, [])

  return (
    <S.timeInput.Wrapper>
      <S.timeInput.InputWrapper className={className} $status={inputProps.status}>
        <S.input.Prefix>
          <glyphs.stroke.Clock size={16} />
        </S.input.Prefix>
        <S.input.Input min="00:00" max="23:59" {...inputProps} ref={setRef} type="time" />
      </S.timeInput.InputWrapper>
      {timezone && <S.timeInput.Timezone>{timezone}</S.timeInput.Timezone>}
    </S.timeInput.Wrapper>
  )
})

export const TimeInput = styled(TimeInputComponent)<TimeInputProps>``
TimeInput.displayName = 'TimeInput'
